"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitorFMP = exports.ELEMENT_TIMING_FMP = void 0;
const atom_1 = require("../../atom");
exports.ELEMENT_TIMING_FMP = 'first-meaningful-paint';
const monitorFMP = () => {
    const callback = (entry) => {
        const { url, loadTime, renderTime } = entry;
        const { key } = window.store.get(atom_1.$Location);
        if (key !== 'default') {
            return;
        }
        const params = {
            value: renderTime,
            rating: (() => {
                if (renderTime < 2500) {
                    return 'good';
                }
                else if (renderTime < 4000) {
                    return 'needs-improvement';
                }
                else {
                    return 'poor';
                }
            })(),
            time_to_first_byte: 0,
            navigation_type: '',
            element_url: '',
            resource_load_delay: 0,
            resource_load_time: 0,
            element_render_delay: 0,
            resource_transfer_size: 0,
        };
        const navigationTiming = window.performance.getEntriesByType('navigation')[0];
        let activationStart = 0;
        let ttfb = 0;
        if (navigationTiming) {
            activationStart = navigationTiming.activationStart || 0;
            ttfb = Math.max(0, navigationTiming.responseStart - activationStart);
            params.time_to_first_byte = ttfb;
            params.navigation_type = navigationTiming.type;
        }
        // image type
        if (url) {
            const resourceTiming = window.performance.getEntriesByName(url)[0];
            if (resourceTiming && navigationTiming) {
                const lcpRequestStart = Math.max(ttfb, 
                // Prefer `requestStart` (if TOA is set), otherwise use `startTime`.
                resourceTiming ? (resourceTiming.requestStart || resourceTiming.startTime) - activationStart : 0);
                const lcpResponseEnd = Math.max(lcpRequestStart, resourceTiming ? resourceTiming.responseEnd - activationStart : 0);
                const lcpRenderTime = Math.max(lcpResponseEnd, resourceTiming.startTime - activationStart);
                params.element_url = url;
                params.resource_load_delay = lcpRequestStart - ttfb;
                params.resource_load_time = lcpResponseEnd - lcpRequestStart;
                params.element_render_delay = lcpRenderTime - lcpResponseEnd;
                params.resource_transfer_size = resourceTiming.transferSize;
            }
        }
        window.Tea('beaconEvent', 'rd_web_fmp', params);
    };
    if ('PerformanceObserver' in window) {
        const observer = new PerformanceObserver((list) => {
            list
                .getEntries()
                .filter((entry) => {
                return entry.identifier === exports.ELEMENT_TIMING_FMP;
            })
                .filter((_, index) => index === 0)
                .forEach((entry) => {
                callback(entry);
                observer.disconnect();
            });
        });
        observer.observe({ type: 'element', buffered: true });
    }
};
exports.monitorFMP = monitorFMP;
